module.exports = __webpack_public_path__ + "media/zero.700d8933.mp3";